import { render } from "./SPurchaser.vue?vue&type=template&id=0c24a0d0"
import script from "./SPurchaser.vue?vue&type=script&lang=js"
export * from "./SPurchaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__